import { render, staticRenderFns } from "./panoramaModal.vue?vue&type=template&id=a0bba3e8&scoped=true&"
import script from "./panoramaModal.vue?vue&type=script&lang=js&"
export * from "./panoramaModal.vue?vue&type=script&lang=js&"
import style0 from "./panoramaModal.vue?vue&type=style&index=0&id=a0bba3e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bba3e8",
  null
  
)

export default component.exports